'use client';

import { useCartClearConfirmation } from '@/hooks/use-cart-clear-confirmation.hook';
import { CartAddIntent } from '@/types/cart-clear-confirmation.types';
import {
  confirmDifferentCity,
  DifferentCityScheduleType,
  DifferentCityTarget,
} from '@/utils/cart/confirm-different-city.util';

export interface UseCartAdditionConfirmationResult {
  confirmCartAddition: (
    target: DifferentCityTarget,
    scheduleType: DifferentCityScheduleType,
    intent: CartAddIntent,
  ) => Promise<boolean>;
}

export function useCartAdditionConfirmation(): UseCartAdditionConfirmationResult {
  const { confirmCartClear } = useCartClearConfirmation();

  async function confirmCartAddition(
    target: DifferentCityTarget,
    scheduleType: DifferentCityScheduleType,
    intent: CartAddIntent,
  ): Promise<boolean> {
    const acceptedDifferentCity = await confirmDifferentCity(target, scheduleType);

    if (!acceptedDifferentCity) {
      return false;
    }

    return confirmCartClear(intent);
  }

  return { confirmCartAddition };
}
